import { ApplyPointsLimitResponse } from './src/service-plugins-types.js';
import { ApplyPointsLimitEnvelope } from './src/interfaces-loyalty-v1-earn-points-limit-provider.public.js';

export * from './src/service-plugins-types';
export { ApplyPointsLimitEnvelope };

/**
 * Returns the number of loyalty points the contact may earn from the order
 * after applying the limit logic.
 *
 * Wix calls this method when a contact is about to earn loyalty points from
 * a paid eCommerce order, after any points-adjustment logic has run. The
 * method runs for orders placed through Wix Stores, Wix Bookings, and other
 * apps that use the Wix eCommerce checkout. It doesn't run for points earned
 * through other triggers, such as Wix Automations actions.
 *
 * Wix uses the returned `adjustedPointsToEarn` value as the final number of
 * points to assign for the order. When the returned value is `0`, an earn
 * attempt is recorded in the contact's loyalty activity history and no
 * points are assigned.
 *
 * **Error handling:** If the implementation returns an error or times out,
 * Wix logs the failure and assigns `pointsToEarn` unchanged. No retries are
 * performed at the service plugin layer.
 */
export declare function applyPointsLimit(
  payload: ApplyPointsLimitEnvelope
): ApplyPointsLimitResponse | Promise<ApplyPointsLimitResponse>;
